import {Button, Col, Form, Input, Row, Space, Typography} from "antd";
import {
  InputFields,
  ListActionButton,
  ModalCustom,
  Notification,
} from "components/common";
import Icon from "assets/icons";
import React, {useEffect, useRef, useState} from "react";
import {columns, columnsFunc, columnsMenu, fields} from "./config";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import ModalRole from "./ModalRole/ModalRole";
import ModalRoleFunction from "./ModalRoleFunction/ModalRoleFunction";
import {authenticationService} from "api";
import {randomId} from "helper/common";
import {checkTokenValidity} from "helper/auth";
import {useAppSelector} from "redux/hooks";
import {tabKeys} from "types/enums";
import ModalRoleMenu from "./ModalRoleMenu/ModalRoleMenu";
import {listTab} from "data/list";
const Role = props => {
  const modalRoleRef = useRef<any>();
  const childRoleRef = useRef<any>();
  const modalRoleFunctionRef = useRef<any>();
  const childRoleFunctionRef = useRef<any>();
  const modalRoleMenuRef = useRef<any>();
  const childRoleMenuRef = useRef<any>();
  const [selectedRoleId, setSelectedRoleId] = useState();
  const [listFunc, setListFunc] = useState<any>();
  const [dataRole, setDataRole] = useState<any>();
  const [dataFunc, setDataFunc] = useState<any>();
  const [dataMenu, setDataMenu] = useState<any>();
  const [form] = Form.useForm();
  const [params, setParams] = useState({page: 1, limit: 10});
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [record, setRecord] = useState();
  const activeTab = useAppSelector(state => state.common.activeTab);
  const handlePaginationChange = (page, pageSize?: number) => {
    setParams({...params, page: page, limit: pageSize});
  };
  const [isAdmin, setIsAdmin] = useState(false);
  const paginationConfig = {
    // trang hiện tại
    total: total, // tổng số phần tử
    // pageSize: limit,
    onChange: handlePaginationChange,
  };
  columnsFunc.find(e => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        deleteFunction={() => {
          deleteFuncFromRole(_record?.id);
        }}
      ></ListActionButton>
    );
  };
  columnsMenu.find(e => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        deleteFunction={() => {
          deleteMenuFromRole(_record?.id, _record?.menu);
        }}
      ></ListActionButton>
    );
  };
  columns.find(e => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        editFunction={() => {
          modalRoleRef?.current?.openModal();
          setRecord(_record);
        }}
        deleteFunction={() => {
          deleteRoleAlina(_record?.ssoId);
        }}
      ></ListActionButton>
    );
  };
  useEffect(() => {
    const checkToken = () => {
      const valid = checkTokenValidity(localStorage.getItem("tokenAdmin"));
      if (valid) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    };
    if (activeTab == tabKeys.AUTHORIZATION.ROLE) {
      checkToken();
    }
  }, [localStorage.getItem("tokenAdmin"), activeTab]);
  const deleteRoleAlina = async id => {
    try {
      await authenticationService.deleteRoleAlina(id);
      getListRoleAlina();
      Notification("success", "Đã xóa role");
    } catch (error) {
      console.log(error);
      Notification("error", "Đã có lỗi khi xóa");
    }
  };
  const getListRoleAlina = async () => {
    try {
      const res = await authenticationService.getListRoleAlina();
      setDataRole(res?.data?.map?.(e => ({...e, key: randomId()})));
    } catch (error) {}
  };
  const getListRoleAlinaByName = async () => {
    try {
      const name = form.getFieldValue("name");
      const res = await authenticationService.getListRoleAlinaByName(name);
      setDataRole(res?.data?.map?.(e => ({...e, key: randomId()})));
    } catch (error) {}
  };
  const getListFuncByRole = async id => {
    try {
      const res = await authenticationService.getListFuncByRoleAlina(id);
      setDataFunc(res);
    } catch (error) {}
  };
  const deleteFuncFromRole = async id => {
    try {
      await authenticationService.deleteFuncFromRole(id);
      getListFuncByRole(selectedRoleId);
      Notification("success", "Đã xóa chức năng");
    } catch (error) {
      console.log(error);
      Notification("error", "Đã có lỗi khi xóa");
    }
  };
  const getListMenuByRole = async id => {
    try {
      const res = await authenticationService.getListMenuByRoleAlina(id);
      setDataMenu(res);
    } catch (error) {}
  };
  const deleteTabFromRole = async menu => {
    try {
      const res = await authenticationService.getListTabByRoleAlina(
        selectedRoleId
      );
      if (res?.length > 0) {
        console.log(menu);
        const _dataTab = JSON.parse(res?.[0]?.tab);
        const remainTab = _dataTab.filter(
          tab => listTab?.find(e => e?.tabKey == tab)?.menuKey != menu
        );
        const params = [
          {
            roleId: selectedRoleId,
            tab: JSON.stringify(remainTab),
            id: res?.[0]?.id,
          },
        ];
        await authenticationService.updateTabToRoleAlina(params);
      } else {
        return;
      }
    } catch (error) {}
  };
  const deleteMenuFromRole = async (id, menu) => {
    try {
      await authenticationService.deleteMenuFromRole(id);
      deleteTabFromRole(menu);
      getListMenuByRole(selectedRoleId);
      Notification("success", "Đã xóa menu");
    } catch (error) {
      console.log(error);
      Notification("error", "Đã có lỗi khi xóa");
    }
  };
  useEffect(() => {
    if (isAdmin) {
      getListRoleAlina();
    }
  }, [isAdmin]);
  const onRowSelect = (selectedRowKeys, selectedRows, info) => {
    setSelectedRoleId(selectedRows[0]?.id);
    getListFuncByRole(selectedRows[0]?.id);
    getListMenuByRole(selectedRows[0]?.id);
  };
  const onFinish = async values => {
    try {
      const res = await authenticationService.loginAdmin(values);
      if (res?.code == 200) {
        setIsAdmin(true);
        localStorage.setItem("tokenAdmin", res?.data?.accessToken);
      } else {
        throw {};
      }
    } catch (error) {
      Notification("error", "Đã có lỗi khi đăng nhập");
    }
  };
  const updateRoleSSO = async () => {
    try {
      const res = await authenticationService.updateRoleSSO();
      Notification("success", "Cập nhật quyền thành công");
    } catch (error) {
      Notification("error", "Đã có lỗi");
    }
  };
  const onKeyDown = e => {
    if (e.key === "Enter") {
      getListRoleAlinaByName();
    }
  };
  return (
    <>
      {isAdmin && (
        <>
          <div className="container" onKeyDown={onKeyDown} tabIndex={0}>
            <Form form={form} labelAlign="left">
              <Row justify={"space-between"} style={{width: "100%"}}>
                <Col span={12}>
                  <Row gutter={[16, 8]}>
                    <InputFields data={fields} />
                    <Col>
                      <Button
                        type="primary"
                        icon={<Icon.search />}
                        onClick={getListRoleAlinaByName}
                      >
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row justify={"end"}>
                    {" "}
                    <Button type="primary" onClick={updateRoleSSO}>
                      Cập nhật quyền
                    </Button>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
          <Row className="container" gutter={[4, 4]}>
            <Col span={12}>
              <Row justify={"end"} style={{marginBottom: 4}}>
                <Button
                  type="primary"
                  onClick={() => {
                    setRecord(null);
                    modalRoleRef?.current?.openModal();
                  }}
                >
                  Thêm role
                </Button>
              </Row>
              <CustomResizableTable
                //   setShowColumns={setShowColumns}
                bordered
                dataSource={dataRole}
                columns={columns}
                // className="custom-resize-table-scroll"
                // scroll={{x: 2500}}
                rowSelection={{
                  type: "radio",
                  onChange: onRowSelect,
                }}
                loading={loading}
                pagination={paginationConfig}
                onRow={record => ({
                  onDoubleClick: () => {
                    modalRoleRef?.current?.openModal();
                    setRecord(record);
                  },
                })}
              />
            </Col>
            <Col span={12}>
              <Row justify={"end"} style={{marginBottom: 4}}>
                <Button
                  type="primary"
                  onClick={() => {
                    modalRoleFunctionRef?.current?.openModal();
                    setRecord(null);
                  }}
                >
                  Thêm chức năng
                </Button>
              </Row>
              <CustomResizableTable
                //   setShowColumns={setShowColumns}
                bordered
                dataSource={dataFunc}
                columns={columnsFunc}
                // className="custom-resize-table-scroll"
                // scroll={{x: 2500}}

                loading={loading}
                pagination={paginationConfig}
                onRow={record => ({
                  onDoubleClick: () => {
                    // modalRoleFunctionRef?.current?.openModal();
                    // setRecord(record);
                  },
                })}
              />
              <Row justify={"end"} style={{marginBottom: 4, marginTop: 4}}>
                <Button
                  type="primary"
                  onClick={() => {
                    modalRoleMenuRef?.current?.openModal();
                    setRecord(null);
                  }}
                >
                  Thêm giao diện
                </Button>
              </Row>
              <CustomResizableTable
                //   setShowColumns={setShowColumns}
                bordered
                dataSource={dataMenu}
                columns={columnsMenu}
                // className="custom-resize-table-scroll"
                // scroll={{x: 2500}}

                loading={loading}
                pagination={paginationConfig}
                onRow={record => ({
                  onDoubleClick: () => {
                    // modalRoleFunctionRef?.current?.openModal();
                    // setRecord(record);
                  },
                })}
              />
            </Col>
          </Row>

          <ModalCustom
            onOpenModal={() => {
              // childRoleRef?.current?.resetFields();
            }}
            draggable
            width={1400}
            ref={modalRoleRef}
            title={`${record ? "Sửa" : "Thêm"} thông tin role`}
          >
            <ModalRole
              ref={childRoleRef}
              record={record}
              getListRoleAlina={getListRoleAlina}
            ></ModalRole>
          </ModalCustom>
          <ModalCustom
            onOpenModal={() => {
              if (dataFunc == null) {
                childRoleFunctionRef?.current?.resetFields();
              }
            }}
            draggable
            width={1400}
            ref={modalRoleFunctionRef}
            title={`Thêm chức năng vào role`}
          >
            <ModalRoleFunction
              selectedRoleId={selectedRoleId}
              dataFunc={dataFunc}
              getListFuncByRole={getListFuncByRole}
              ref={childRoleFunctionRef}
            ></ModalRoleFunction>
          </ModalCustom>
          <ModalCustom
            onOpenModal={() => {
              if (dataMenu == null) {
                childRoleMenuRef?.current?.resetFields();
              }
            }}
            draggable
            width={500}
            ref={modalRoleMenuRef}
            title={`Thêm menu vào role`}
          >
            <ModalRoleMenu
              selectedRoleId={selectedRoleId}
              dataMenu={dataMenu}
              getListMenuByRole={getListMenuByRole}
              ref={childRoleMenuRef}
            ></ModalRoleMenu>
          </ModalCustom>
        </>
      )}
      {!isAdmin && (
        <div
          className="container"
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Form
            style={{width: 600}}
            form={form}
            // layout="vertical"
            requiredMark={false}
            onFinish={onFinish}
          >
            <Space direction="vertical" style={{width: "100%"}}>
              <Row justify={"center"}>
                <Typography.Text className="login-description" type="secondary">
                  Đăng nhập để sử dụng chức năng này
                </Typography.Text>
              </Row>
              <Form.Item
                name="username"
                rules={[
                  {required: true, message: "Vui lòng nhập tên đăng nhập!"},
                ]}
              >
                <Input placeholder="Tên đăng nhập" />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{required: true, message: "Vui lòng nhập mật khẩu!"}]}
              >
                <Input.Password placeholder="Mật khẩu" />
              </Form.Item>

              <Row justify={"center"}>
                <Button
                  type="primary"
                  className="login-btn btn-sub"
                  htmlType="submit"
                >
                  Đăng nhập
                </Button>
              </Row>
            </Space>
          </Form>
        </div>
      )}
    </>
  );
};
export default Role;
